import { Injectable } from "@angular/core";
import { Action, State, StateContext, Store } from "@ngxs/store";
import { map } from "rxjs/operators";
import { CandidateProgress } from "../model/model";
import { CandidateProgressService } from "../services/candidateprogress.service";
import { LocalstorageService } from "../services/localstorage-service.service";
import { UserService } from "../services/user.service";
import { CitoApplicationModule, ProfileData, User } from "./../model/model";
import { DashboardState } from "./dashboard.state";
import { PlanningState } from "./planning.state";

export class LoadCandidateProgressAction {
  static type = "[Candidate progress] Load";
  constructor(public candidateId: string) {}
}

export class UpdateNameAction {
  static type = "[Candidate progress] Update name";
  constructor(public candidateId: string, public newname: string) {}
}

export class UpdateProfileAction {
  static type = "[Candidate progress] Update profile";
  constructor(public candidateId: string, public profile: string[]) {}
}

export interface CandidateProgressStateModel {
  loading: boolean;
  progress: CandidateProgress;
  candidate: User;
}

export const initialState = {
  loading: true,
  progress: null,
  editingName: false,
  candidate: null,
};
@State<CandidateProgressStateModel>({
  name: "candidateprogress",
  defaults: initialState,
})
@Injectable()
export class CandidateProgressState {
  constructor(
    private candidateProgressService: CandidateProgressService,
    private userService: UserService,
    private storageService: LocalstorageService,
    private store: Store
  ) {}

  @Action(UpdateNameAction)
  updateName(
    ctx: StateContext<CandidateProgressStateModel>,
    action: UpdateNameAction
  ) {
    ctx.patchState({
      progress: { ...ctx.getState().progress, candidateName: action.newname },
    }); // being optimistic here
  }

  @Action(UpdateNameAction)
  updatingName(
    _ctx: StateContext<CandidateProgressStateModel>,
    action: UpdateNameAction
  ) {
    return this.userService.updateName(action.candidateId, action.newname);
  }

  @Action(UpdateProfileAction)
  updateProfile(
    ctx: StateContext<CandidateProgressStateModel>,
    action: UpdateProfileAction
  ) {
    const citomodule = this.store.selectSnapshot(DashboardState.citomodule);

    if (citomodule === CitoApplicationModule.Rekenen) {
      ctx.patchState({
        candidate: {
          ...ctx.getState().candidate,
          learningRoutesList: action.profile,
        },
      });
    } else if (citomodule === CitoApplicationModule.Spelling) {
      ctx.patchState({
        candidate: {
          ...ctx.getState().candidate,
          learningRoutesSpellingList: action.profile,
        },
      });
    }
  }

  @Action(UpdateProfileAction)
  updatingProfile(
    _ctx: StateContext<CandidateProgressStateModel>,
    action: UpdateProfileAction
  ) {
    const candidate = _ctx.getState().candidate;
    const profile: ProfileData = {
      learningRoutes: candidate.learningRoutesList,
      learningRoutesSpelling: candidate.learningRoutesSpellingList,
    };
    return this.userService.updateProfile(action.candidateId, profile);
  }

  @Action(LoadCandidateProgressAction)
  loadCandidateProgress(ctx: StateContext<CandidateProgressStateModel>) {
    ctx.patchState({ loading: true });
  }

  @Action(LoadCandidateProgressAction)
  loadingCandidateProgress(
    ctx: StateContext<CandidateProgressStateModel>,
    action: LoadCandidateProgressAction
  ) {
    const candidates = this.store.selectSnapshot(PlanningState.candidates);
    const candidate = candidates.find(
      (candidate) => candidate.id === action.candidateId
    );
    return this.candidateProgressService
      .get(action.candidateId)
      .pipe(
        map((progress) =>
          ctx.patchState({
            loading: false,
            progress: progress,
            candidate: candidate,
          })
        )
      );
  }
}
